import { SocialLinksForm } from "./SocialLinksForm";
import { UploadAvatar } from "./UploadAvatar";
import "./styles/VerifyStep.scss";

interface IVerifyStepProps {
  index: number;
  title: string;
  text: string;
  list?: string[];
  handleUpdateInputs: (inputs: IInput[]) => void;
  handleChangeFile: (data: IFileData | null) => void;
  inputList: IInput[];
  btnState: boolean;
  disableSubmit: boolean;
  userName: string | null;
  handleVerifySend: () => void;
}

export interface IFileData {
  file_data: File;
  file_name: string;
}

export interface IInput {
  id: string;
  name: null | string;
  value: string;
  validMessage: null | string;
  isRequired: boolean;
}

// eslint-disable-next-line max-len
export const VerifyStep = (props: IVerifyStepProps) => {
  const {
    index,
    title,
    text,
    list,
    handleUpdateInputs,
    handleChangeFile,
    inputList,
    btnState,
    disableSubmit,
    handleVerifySend,
    userName
  } = props;

  const renderActionColumn = () => {
    if (index === 1) {
      return (
        <SocialLinksForm handleUpdateInputs={handleUpdateInputs} inputList={inputList} />
      );
    }

    if (index === 2) {
      return (
        <UploadAvatar onChange={handleChangeFile} />
      );
    }

    if (index === 3) {
      return (
        <div className="VerifyStep-VerifyWrap">
          <button className="VerifyStep-VerifyBtn" disabled={disableSubmit || !btnState} onClick={handleVerifySend}>
            Verify Account
          </button>
        </div>
      );
    }
  };

  const renderListItems = () => {
    if (!list) {
      return null;
    }

    return (
      <div className="VerifyStep-List">
        {list.map((title: string, idx: number) => {
          return <p key={idx}>
            {title}
            {" "}
            {index === 2 && idx === 0 && (
              <a
                href={`https://www.redgifs.com/users/${userName}`}
                target="_blank"
                rel="noreferrer"
              >{`https://www.redgifs.com/users/${userName}`}</a>
            )}
          </p>;
        })}
      </div>
    );
  };

  return (
    <div className="VerifyStep">
      <div className="VerifyStep-Column">
        <div className="VerifyStep-Title">
          <span>{index}</span>
          <h4>{title}</h4>
        </div>
        <p className="VerifyStep-Text">{text}</p>
        {renderListItems()}
      </div>
      <div className="VerifyStep-Column">
        {renderActionColumn()}
      </div>
    </div>
  );
};
